<ng-container *ngIf="!isMobile; else mobileView">
  <ion-content class="tipoApuesta background-color-muted">
    <!-- user-section-title mobile & desktop -->
    <user-section-title [sectionTitle]="'CodereCardMybetsLocal'"></user-section-title>

    <ion-row class="subHeaderSelects">
      <ion-col>
        <ion-list>
          <ion-item>
            <ion-label>{{ 'hStade' | translate }} </ion-label>
            <ion-select
              cancelText="{{ 'tCancel' | translate }}"
              okText="Ok"
              placeholder="{{ 'histaptodas' | translate }}"
              [(ngModel)]="form.myType"
              (ionChange)="update()"
              class="combo-fechas"
            >
              <ion-select-option value="All" checked="true">{{ 'histaptodas' | translate }}</ion-select-option>
              <ion-select-option value="4">{{ 'histapabiertas' | translate }}</ion-select-option>
              <ion-select-option value="1">{{ 'histapganadas' | translate }}</ion-select-option>
              <ion-select-option value="3">{{ 'histapperdidas' | translate }}</ion-select-option>
              <ion-select-option value="5">{{ 'histapcobrada' | translate }}</ion-select-option>
              <ion-select-option value="0">{{ 'histapotras' | translate }}</ion-select-option>
            </ion-select>
            <ion-icon ios="ios-arrow-dropdown" md="md-arrow-dropdown"></ion-icon>
          </ion-item>
        </ion-list>
      </ion-col>

      <ion-col>
        <ion-list>
          <ion-item>
            <ion-label>{{ 'histapfecha' | translate }} </ion-label>
            <ion-select
              cancelText="{{ 'tCancel' | translate }}"
              okText="Ok"
              placeholder="{{ 'histapu15d' | translate }}"
              [(ngModel)]="form.date"
              (ionChange)="update()"
              class="combo-fechas"
            >
              <ion-select-option value="365">{{ 'histaptodas' | translate }}</ion-select-option>
              <ion-select-option value="90">{{ 'histapu90d' | translate }}</ion-select-option>
              <ion-select-option value="30">{{ 'last30days' | translate }}</ion-select-option>
              <ion-select-option value="lastmonth">{{ 'lastmonth' | translate }}</ion-select-option>
              <ion-select-option value="15" checked="true">{{ 'histapu15d' | translate }}</ion-select-option>
              <ion-select-option value="7">{{ 'histapu7d' | translate }}</ion-select-option>
              <ion-select-option value="2">{{ 'histapu2d' | translate }}</ion-select-option>
            </ion-select>
          </ion-item>
        </ion-list>
      </ion-col>
    </ion-row>
    <div class="is-narrow-content">
      <!--Empty State-->
      <empty-state
        [message]="'noBet'"
        [subMessage]="'noBetMsg'"
        [imageSource]="imageSource"
        [hidden]="!arrTickets || arrTickets?.length !== 0"
      ></empty-state>
      <!--My bet ticket history-->
      <ion-list *ngFor="let ticket of arrTickets">
        <ion-list-header class="header-fecha">{{ ticket.TicketsDatetime | sportsExtractDate: [1] }}</ion-list-header>
        <!-- todo no se para que sirve -->
        <!-- [token]="token" -->
        <my-bet-ticket
          [ticket]="ticket"
          [globalVars]="globalVars"
          (selectBet)="loadDetails($event)"
          (cashout)="payOutTicket($event)"
        ></my-bet-ticket>
      </ion-list>
    </div>
    <codere-footer></codere-footer>
  </ion-content>
</ng-container>
<ng-template #mobileView>
  <ion-header>
    <user-section-title [sectionTitle]="'CodereCardMybetsLocal'"></user-section-title>
  </ion-header>
  <!-- todo [ngClass]="{'no-scroll': globalVars?.iosScrollHide}" -->
  <ion-content class="tipoApuesta background-color-muted" [ngClass]="{'no-scroll': globalVars?.iosScrollHide}">
    <ion-row class="subHeaderSelects">
      <ion-col>
        <ion-list>
          <ion-item>
            <ion-label>{{ 'hStade' | translate }} </ion-label>
            <ion-select
              cancelText="{{ 'tCancel' | translate }}"
              okText="Ok"
              placeholder="{{ 'histaptodas' | translate }}"
              [(ngModel)]="form.myType"
              (ionChange)="update()"
            >
              <ion-select-option value="All" checked="true">{{ 'histaptodas' | translate }}</ion-select-option>
              <ion-select-option value="4">{{ 'histapabiertas' | translate }}</ion-select-option>
              <ion-select-option value="1">{{ 'histapganadas' | translate }}</ion-select-option>
              <ion-select-option value="3">{{ 'histapperdidas' | translate }}</ion-select-option>
              <ion-select-option value="5">{{ 'histapcobrada' | translate }}</ion-select-option>
              <ion-select-option value="0">{{ 'histapotras' | translate }}</ion-select-option>
            </ion-select>
            <ion-icon ios="ios-arrow-dropdown" md="md-arrow-dropdown"></ion-icon>
          </ion-item>
        </ion-list>
      </ion-col>

      <ion-col>
        <ion-list>
          <ion-item>
            <ion-label>{{ 'histapfecha' | translate }} </ion-label>
            <ion-select
              cancelText="{{ 'tCancel' | translate }}"
              okText="Ok"
              placeholder="{{ 'histapu15d' | translate }}"
              [(ngModel)]="form.date"
              (ionChange)="update()"
            >
              <ion-select-option value="365">{{ 'histaptodas' | translate }}</ion-select-option>
              <ion-select-option value="90">{{ 'histapu90d' | translate }}</ion-select-option>
              <ion-select-option value="30">{{ 'last30days' | translate }}</ion-select-option>
              <ion-select-option value="lastmonth">{{ 'lastmonth' | translate }}</ion-select-option>
              <ion-select-option value="15" checked="true">{{ 'histapu15d' | translate }}</ion-select-option>
              <ion-select-option value="7">{{ 'histapu7d' | translate }}</ion-select-option>
              <ion-select-option value="2">{{ 'histapu2d' | translate }}</ion-select-option>
            </ion-select>
          </ion-item>
        </ion-list>
      </ion-col>
    </ion-row>
    <!--SectionTitle-->

    <!--Empty State-->
    <empty-state
      [class.is-mobile]="isMobile"
      [message]="'noBet'"
      [subMessage]="'noBetMsg'"
      [imageSource]="imageSource"
      [hidden]="!arrTickets || arrTickets?.length !== 0"
    ></empty-state>

    <!--Mis apuestas Presenciales-->
    <ion-list clear *ngFor="let ticket of arrTickets" [hidden]="!arrTickets || arrTickets?.length === 0" padding>
      <ion-list-header> {{ ticket.TicketsDatetime | sportsExtractDate: [1] }} </ion-list-header>
      <!-- todo no se para que sirve -->
      <!-- [token]="token" -->
      <my-bet-ticket [ticket]="ticket" (selectBet)="loadDetails($event)" (cashout)="payOutTicket($event)">
      </my-bet-ticket>

      <!-- todo pendiente de validar contra backend -->
      <ion-item
        *ngFor="let result of ticket.betHistoryInfo"
        tappable="true"
        (click)="openBetDetail(result.TicketNumber, result)"
      >
        <ion-label>
          <h2 class="eventAp">{{result.betEvents[0].EventName | sportsFormatTitleEvent}}</h2>

          <p class="typeAp">
            {{'tApues'|translate}} {{result.BetType}} (<span *ngIf="result.BetTypeNumber!='1'">{{result.X}}</span
            ><span *ngIf="result.X!=result.Y || result.BetTypeNumber=='1'"
              ><span *ngIf="result.BetTypeNumber!='1'">/</span><span>{{result.Y}}</span></span
            >)

            <span [ngSwitch]="result.TicketStatusNumber">
              <b *ngSwitchCase="'4'" class="openBet">
                {{result.TicketStatus}}<i *ngIf="result.VoucherCode==null && getEarlyCashoutEnabled()"
                  >{{'Cobrarya' | translate}}</i
                >
              </b>
              <b *ngSwitchCase="'1'" class="winBet">
                {{result.PotentialWinnings | sportsParseMoney}} {{result.TicketStatus}}
              </b>
              <b *ngSwitchCase="'3'" class="noWinBet"> {{result.TicketStatus}} </b>
              <b *ngSwitchCase="'5'" class="noWinBet"> {{result.TicketStatus}} </b>
              <b *ngSwitchCase="'0'" class="cancelBet"> {{result.TicketStatus}} </b>
            </span>
            <img src="assets/global/img/logobue.png" alt="" class="hideTemp" />
          </p>
        </ion-label>
        <i item-right class="codere-icon arrow icon-arrow-right"></i>
      </ion-item>
    </ion-list>
    <codere-footer></codere-footer>
  </ion-content>
</ng-template>
